import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const FreeRentNamedItem = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const freeRentOptions = _.map(props.namedItems['freeRent'], (fr) => { return {label: fr.code, value: fr.freerentid} })
  const emptyRecord = {
    freeRentNamedItemId: null
  }
  const _data = (rowData) => ({
    ...rowData[props.field]
  })
  const [data, setData] = useState<object|null>(_data(props.rowData));

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'namedItem') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val

    delete nextData.amt
    delete nextData.amtType
    delete nextData.revenue
    delete nextData.items

    setData(nextData);
    props.persist({...nextData, state: 'namedItem'}, 'freerentdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Named Free Rent</label>
          <DropdownInput
            className="automated"
            data={data}
            attrs={attrs}
            field="freeRentNamedItemId"
            filter={true}
            options={freeRentOptions}
            persist={updateData}
          />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default FreeRentNamedItem
